<template>
	<v-date-picker
		class="cursor-pointer"
		:value="value"
		color="indigo"
		:min-date="minDate"
		:max-date="maxDate"
		@input="changeValue"
	>
		<template #default="{ inputValue, togglePopover }">
			<div class="w-full">
				<label
					class="text-label"
					:for="id"
					>{{ label }}</label
				>
				<div class="datepicker">
					<Icon
						icon="fa-solid:calendar"
						@click="togglePopover({ placement: 'auto-start' })"
					/>
					<div class="text-label w-full">
						<input
							:id="id"
							class="w-full outline-none"
							type="text"
							:placeholder="placeholder || label"
							:readonly="true"
							:value="inputValue"
							@click="togglePopover({ placement: 'auto-start' })"
						/>
					</div>
				</div>
			</div>
		</template>
	</v-date-picker>
</template>

<script>
import { Icon } from '@iconify/vue2'
export default {
	components: {
		Icon,
	},
	props: {
		/**
		 * Id do componente
		 */
		id: String,
		/**
		 * Label do componente
		 */
		label: String,
		/**
		 * Placeholder do componente
		 */
		placeholder: String,
		/**
		 * Valor que sera feito o bind
		 */
		value: { type: String, default: () => new Date().toISOString() },
		/**
		 * Valor minimo para a data
		 */
		minDate: String,
		/**
		 * Valor maximo para a data
		 */
		maxDate: String,
	},
	mounted() {
		//TODO Trocar as referências para a lib @treevia/smartforest-ui
		console.warn(
			'DataPicker está depreciado, considere utilizar o DataPicker da lib @treevia/smartforest-ui',
		)
	},
	methods: {
		changeValue(date) {
			this.$emit('input', date.toISOString())
		},
	},
}
</script>

<style scoped>
input::placeholder {
	@apply text-sm text-[#737576];
}

.datepicker {
	@apply border border-[#737576] rounded-[4px] flex items-center px-2 bg-white gap-2 mt-1;
}

input {
	@apply border-none leading-7;
}
</style>
